import React from "react";
import ReactDOM from "react-dom/client";
import SchemaPortalApp from "./SchemaPortalApp";
import "./i18n";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <SchemaPortalApp />
    </React.StrictMode>
);
